import * as React from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import TransitionBlock from '../TransitionBlock'
import { formatBezierCurveCSS } from '../../utils';
import './characterBlock.scss';

export default class CharacterMultiLineBlock extends React.Component {
	constructor(props) {
		super(props)
		this.state = {lines: [] };
		this.editTextArea = null;
	}

	componentDidMount() {
		this.generateCharacters();	
	}

	setTextAreaRef = (ref) => {
		this.editTextArea = ref;
	}

	onFocus = () => {
		this.onEdit();
	}

	onBlur = () => {
		this.onAccept();
	}	

	onAccept = () => {
		const {onEditModeChange} = this.props;
		this.generateCharacters();
		onEditModeChange(false);
	}

	onEdit = () => {
		const {onEditModeChange} = this.props;

		setTimeout(() => {
			if(this.editTextArea) {
				this.editTextArea.focus();
			}
		}, 200);

		onEditModeChange(true);
	}

	generateCharacters = () => {
		const { copy } = this.props;
		const lines = copy.split('\n');
		const wordLines = lines.map(line => {
			return line.split(" "); // separate by word 
		});
		
		const characterLines = wordLines.map(word => {
			return word.map(w => w.split("")); // separate by character
		});
		
		this.setState({ lines: characterLines });
	}

	render() {
		const { copy, onChange, transitionOptions, inEditMode } = this.props;
		const {lines } = this.state;
		const bezierCurve = formatBezierCurveCSS(transitionOptions.bezierCurve);

		return (
			<div className="multiline-editor" onKeyDown={this.onKeyDown}>

				<div className={`multiline-editor__textarea ${inEditMode ? '' : 'hidden'}`} >
					<LineWrapper {...this.props}>
						<TextareaAutosize
							inputRef={ref => this.setTextAreaRef(ref)}
							value={copy}
							placeholder="Enter your wittiest copy"
							onChange={onChange}
							onFocus={this.onFocus}
							onBlur={this.onBlur}
							onKeyDown={this.onKeyDown}
						/>
					</LineWrapper>
				</div>

				{!inEditMode && <div className={`character-iew__wrapper`}>
					{lines.map((line, i) => {

						// We must keep track of what character we are on for animation purposes
						let characterCount = 0;

						return (
							<LineWrapper key={i} {...this.props} onClick={this.onEdit}>
							{line.map((word, j) => {	

								characterCount = characterCount + word.length;
							
								return (
									
									<WordWrapper key={j} transitionOptions={transitionOptions}>
										{word.map((character, k, wordArray) => {

											return (
												<CharacterWrapper key={k} {...this.props} >
													<TransitionBlock
														{...transitionOptions}
														triggerOnce
														from={transitionOptions.direction}
														delay={(i * transitionOptions.multilineOffsetDelay) + ((characterCount - wordArray.length + k) * transitionOptions.characterOffsetDelay)}
														animateOpacity={transitionOptions.opacity}
														duration={transitionOptions.duration}
														offset={`${transitionOptions.offset}px`}
														transition={bezierCurve}
														opacityDelay={(i * transitionOptions.opacityDelay) + ((characterCount - wordArray.length + k) * transitionOptions.opacityDelay)}
													>
														{character}
													</TransitionBlock>
												</CharacterWrapper>);
										})}
									</WordWrapper>
								
								);
							})}							
							</LineWrapper>);
						}
					)}
					</div>

				}

			</div>
		)
	}
}

class LineWrapper extends React.PureComponent {
	render() {
		const { transitionOptions, fontOptions, onClick, staticView } = this.props;
		
		return <div onClick={onClick}
			style={{
				display: 'block',
				fontFamily: fontOptions.customFont ? `'${fontOptions.customFont}'` : fontOptions.family,
				fontWeight: fontOptions.fontWeight,
				fontSize: `${fontOptions.size}px`,
				color: staticView ? 'white' : fontOptions.color,
				lineHeight: `${fontOptions.lineHeight}px`,
				letterSpacing: `${fontOptions.letterSpacing}em`,
				maxWidth: `${fontOptions.maxWidth}px`,
				width: `${fontOptions.maxWidth}px`,
				overflow: `${transitionOptions.multilineMasking ? 'hidden' : 'visible'}`,
			}}
		>
			{this.props.children}
		</div>
	}
};


class WordWrapper extends React.PureComponent {
	render() {
		const { transitionOptions } = this.props;

		return <div
			style={{
				display: 'inline-block',
				marginRight: `${transitionOptions.characterWordSpacing}px`,
			}}
		>
			{this.props.children}
		</div>
	}
};


class CharacterWrapper extends React.PureComponent {
	render() {
		const { fontOptions, onClick , staticView} = this.props;

		return <div onClick={onClick}
			style={{
				display: 'inline-block',
				fontFamily: fontOptions.customFont ? `'${fontOptions.customFont}'` : fontOptions.family,
				fontWeight: fontOptions.fontWeight,
				fontSize: `${fontOptions.size}px`,
				color: staticView ? 'white' : fontOptions.color,
				lineHeight: `${fontOptions.lineHeight}px`,
				letterSpacing: `${fontOptions.letterSpacing}em`,
				maxWidth: `${fontOptions.maxWidth}px`,
				width: 'auto',
				pointerEvents: staticView ? 'none' : 'normal'
			}}
		>
			{this.props.children}
		</div>
	}
};
